import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searching'
})
export class SearchingPipe implements PipeTransform {


  transform(value: any, arrlist: any): any {
debugger;
    if(!value)return null;
    if(!arrlist)return value;

    arrlist = arrlist.toLowerCase();

    return value.filter(function(item){
      debugger;
        return JSON.stringify(item).toLowerCase().includes(arrlist);
    });
      }


}
